import { httpClient } from '@/services/http/httpClient'

type RequestChangesParams = {
  ideaId: string
  message: string
}

export async function requestChanges({
  ideaId,
  message,
}: RequestChangesParams) {
  await httpClient.post('/ideas/funnel/change-requests', {
    ideaId,
    message,
  })
}
